/**
 * API de gift cards usando Axios.
 */
import { axiosInstance } from "features/shared/api";
import { walletApi } from "features/wallet/api";
import { processTransactionsResponse } from "features/transactions/api/transactionsApi";
import type {
    GiftCardCatalogDto,
    GiftCardDetailResponse,
    BuyGiftCardRequest,
    PaginatedTransactionsDto,
    PaginatedResolvedTransactions,
} from "common/models";

export interface GetPurchasedParams {
    organizationAddress: string;
    page?: number;
    pageSize?: number;
    query?: string;
    address?: string;
    order?: "ASC" | "DESC";
    orderBy?: string;
    startDate?: number;
    endDate?: number;
    mode?: "sent" | "received";
}

export const giftcardsApi = {
    getAllCards: () =>
        axiosInstance
            .get<GiftCardCatalogDto[]>("/api/gift-cards/all")
            .then((r) => r.data),

    getCardDetail: (card: string, source: string) =>
        axiosInstance
            .get<GiftCardDetailResponse>(`/api/gift-cards/${card}`, {
                params: { source },
            })
            .then((r) => r.data),

    payGiftCard: (requestBody: BuyGiftCardRequest) =>
        axiosInstance
            .post<string>("/api/gift-cards", requestBody)
            .then((r) => r.data),

    getPurchasedCards: (params: GetPurchasedParams) =>
        axiosInstance
            .get<PaginatedTransactionsDto>("/api/gift-cards/purchased", { params })
            .then((r) => r.data),

    getPurchasedCardsResolved: async (params: GetPurchasedParams): Promise<PaginatedResolvedTransactions> => {
        const res = await giftcardsApi.getPurchasedCards(params);
        return processTransactionsResponse(res);
    },
};
